/**
 * @generated SignedSource<<067c7b281961be390f373c6079d10870>>
 * @relayHash c364d4091993eebcae6bd6d01b4947d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 99b9c23cf845dc0a36dacd9fa97fdd236f700d39fc2d1913e16976519ede7542

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraSoftwareSummaryAppQuery } from './JiraSoftwareSummaryAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraSoftwareSummaryAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "99b9c23cf845dc0a36dacd9fa97fdd236f700d39fc2d1913e16976519ede7542",
    "metadata": {},
    "name": "JiraSoftwareSummaryAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
